
import customBtn from '@/components/common/btn/custom-btn.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import {
  getXunJiaInfo3Cookie,
  setXunJiaInfo3Cookie,
  judgeEncryptPhoneIsSameEnv,
} from '@/composables/use-cookie-function'
import sensors from '@/utils/sensors'
import {
  countAd,
  // fetchAppUserInfo,
  fetchVerifyCtrl,
  fetchDriveVerifyCtrl,
  postEnrollForm,
  postDriveEnrollForm,
  sendCaptcha,
  sendDriveCaptcha,
  fetchEncryptInfo,
} from '@/http/api'

import {
  defineComponent,
  reactive,
  toRefs,
  onBeforeMount,
  computed,
  watch,
  ref,
} from 'vue'
import { Toast } from 'vant'
import { getCookie } from '@/utils/cookie-storage'
import { isAndroid, isiOS } from '@/utils/runTimeEnv'
export default defineComponent({
  components: { customBtn },
  name: 'coupon-popup',
  emits: ['toggleEnrollPopup', 'enrollSuccess'],
  props: {
    enrollSgInfo: {
      // 弹窗留资车系信息
      type: Object,
      default() {
        return {}
      },
    },
    isShowPopup: {
      type: Boolean,
    },
  },
  setup(props: any, { emit }) {
    const phoneInputRef = ref()
    const route = useRoute()
    const store = useStore()
    const data = reactive({
      activityInfo: computed(() => store.state.activityInfo),
      locationInfo: computed(() => store.state.locationInfo),
      pcsuv: computed(() => store.state.pcsuv),
      captchaNeedVerify: false,
      checkBoxNeedVerify: false,
      browserEnv: computed(() => store.state.browserEnv),
      appLoginCookieKey: computed(() => store.state.appLoginCookieKey),
      appLoginCookieValue: computed(() => store.state.appLoginCookieValue),
      sensitivePhone: '', // 脱敏号码
      resTime: 0, // 验证码倒计时
      timer: null as any, // 验证码定时器
      isReadOnly: false,
      postForm: {
        actId: 0,
        brand: '',
        brandId: 0,
        captcha: '',
        city: '',
        cityId: 0,
        currentFrom: '',
        dealerId: 0,
        locationMessage: '',
        locationType: 0,
        locationVersion: 0,
        pcsuv: '' as any,
        phone: '',
        serialGroupId: 0,
        serialGroupName: '',
        source: 0,
        sourceDetail: 0,
        encryptPhone: '',
        expireTime: '',
        discount: '',
      },
    })
    watch(
      () => props.isShowPopup,
      nVal => {
        if (nVal === true) {
          let cookiePhoneObj: any = getXunJiaInfo3Cookie()
          if (data.browserEnv === 1) {
            data.isReadOnly = store.state.appPhone ? true : false
            data.postForm.phone = store.state.appPhone
              ? store.state.appSensitivePhone + '(上次使用)'
              : ''
            data.postForm.encryptPhone = store.state.appEncryptPhone
          } else {
            if (
              cookiePhoneObj &&
              cookiePhoneObj.phone &&
              cookiePhoneObj.encryptPhone &&
              judgeEncryptPhoneIsSameEnv(cookiePhoneObj.type)
            ) {
              data.isReadOnly = true
              data.postForm.phone = cookiePhoneObj.phone + '(上次使用)'
              data.postForm.encryptPhone = cookiePhoneObj.encryptPhone
            }
          }
          methods.getVerifyCtrl()
        }
      },
    )
    const methods = {
      // 清空电话号码
      clearPhone() {
        data.postForm.phone = ''
        data.postForm.encryptPhone = ''
        data.isReadOnly = false
        phoneInputRef.value.focus()
      },
      // 限制只输入数字
      handleKeyInput(e: any, type: string, maxLen: number) {
        e.target.value = e.target.value.replace(/[^\d]/g, '')
        if (e.target.value.length > maxLen) {
          e.target.value = e.target.value.slice(0, maxLen)
        }
        if (type === 'phone') {
          data.postForm.phone = e.target.value
        } else if (type === 'captcha') {
          data.postForm.captcha = e.target.value
        }
      },
      // 获取验证码和勾选框状态
      async getVerifyCtrl() {
        if (data.browserEnv === 1) {
          // app
          data.postForm.source = 2
        } else if (data.browserEnv === 2 || data.browserEnv === 3) {
          // h5或微信浏览器
          data.postForm.source = 1
        }
        const res: any =
          props.enrollSgInfo.type === 1
            ? await fetchDriveVerifyCtrl({ source: data.postForm.source })
            : await fetchVerifyCtrl({ source: data.postForm.source })
        if (res.code === 200) {
          data.captchaNeedVerify = res.data.captchaNeedVerify
          data.checkBoxNeedVerify = res.data.checkBoxNeedVerify
        }
      },
      // 获取验证码
      async getCaptcha() {
        if (data.resTime === 0) {
          if (data.timer) {
            clearInterval(data.timer)
          }
          // 手机号
          if (!data.postForm.phone) {
            Toast('手机号不能为空')
            return false
          }
          if (
            !data.postForm.phone.includes('*') &&
            !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
              data.postForm.phone,
            )
          ) {
            Toast('请输入正确的手机号码')
            return false
          }
          /** 获取加密手机号 s **/

          // 非手动输入
          if (!data.postForm.phone.includes('*')) {
            let EtguardInfoRes: any = await fetchEncryptInfo({
              phones: window.encryStr(data.postForm.phone), // 手动输入的号码
            })
            if (EtguardInfoRes.code === 1) {
              data.postForm.encryptPhone = EtguardInfoRes.msg[0].encrypt
            } else {
              Toast('加密失败')
              return
            }
          }
          /** 获取加密手机号 e **/

          const res =
            props.enrollSgInfo.type === 1
              ? await sendDriveCaptcha({
                  phone: data.postForm.encryptPhone || data.postForm.phone,
                  encrypt: data.postForm.encryptPhone ? 1 : 0,
                })
              : await sendCaptcha({
                  phone: data.postForm.encryptPhone || data.postForm.phone,
                  encrypt: data.postForm.encryptPhone ? 1 : 0,
                })
          // 0-发送成功，1-手机号不能为空，2-请勿频繁发送验证码，3-超过限定次数，请明日再来，4-活动太火爆,请稍候再试
          if (res.data.code === 0) {
            Toast('发送成功')
            data.resTime = 60
            data.timer = setInterval(() => {
              if (data.resTime === 0) {
                clearInterval(data.timer)
                data.timer = null
              } else {
                data.resTime -= 1
              }
            }, 1000)
          } else {
            Toast(res.data.msg)
          }
        }
      },
      toggleEnrollPopup(value: boolean) {
        emit('toggleEnrollPopup', value)
        methods.clearForm()
      },
      statementClick() {
        data.checkBoxNeedVerify = !data.checkBoxNeedVerify
      },
      setPhoneSensitive(phone: any) {
        return phone.slice(0, 3) + '****' + phone.slice(7, 11)
      },
      verifiyForm() {
        // 手机号校验
        if (!data.postForm.phone) {
          Toast('手机号不能为空')
          return
        }
        if (
          !data.postForm.phone.includes('*') &&
          !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
            data.postForm.phone,
          )
        ) {
          Toast('请输入正确的手机号码')
          return
        }
        // 验证码校验
        if (data.captchaNeedVerify && !data.postForm.captcha) {
          Toast('验证码不能为空')
          return
        }
        if (
          data.captchaNeedVerify &&
          String(data.postForm.captcha).length < 6
        ) {
          Toast('请输入正确的验证码')
          return
        }
        if (!data.checkBoxNeedVerify) {
          Toast('请勾选同意《个人信息披露及保护声明》')
          return
        }
        // 勾选框校验
        return true
      },
      clearForm() {
        data.postForm.phone = ''
        data.postForm.captcha = ''
        data.checkBoxNeedVerify = false
      },
      async submitForm() {
        countAd(6315)
        if (!methods.verifiyForm()) return
        // 获取加密手机号
        let cookiePhoneObj = getXunJiaInfo3Cookie()
        let sensitivePhone =
          data.postForm.phone.slice(0, 3) +
          '****' +
          data.postForm.phone.slice(7, 11)
        let curPhone = ''
        if (data.postForm.phone.slice(0, 11).includes('*')) {
          curPhone =
            data.browserEnv === 1
              ? store.state.appPhone
                ? store.state.appPhone
                : data.postForm.phone.slice(0, 11)
              : data.postForm.phone.slice(0, 11)
        } else {
          curPhone = data.postForm.phone.slice(0, 11)
        }
        // 有cookie
        if (
          data.browserEnv !== 1 &&
          cookiePhoneObj &&
          cookiePhoneObj.phone &&
          cookiePhoneObj.encryptPhone &&
          cookiePhoneObj.phone === sensitivePhone
        ) {
          data.postForm.encryptPhone = cookiePhoneObj.encryptPhone
        } else {
          let EtguardInfoRes: any = await fetchEncryptInfo({
            phones: window.encryStr(curPhone), // 手动输入的号码
          })
          if (EtguardInfoRes.code === 1) {
            data.postForm.encryptPhone = EtguardInfoRes.msg[0].encrypt
          } else {
            Toast('加密失败')
            return
          }
        }
        // source
        if (data.browserEnv === 1) {
          data.postForm.source = 2

          // app发送收集的用户信息内容
          try {
            const userCollectInfo = {
              phoneNum: data.postForm.phone,
            }
            if (isiOS()) {
              window.webkit.messageHandlers.PCJSKit.postMessage({
                functionName: 'setUserCollectInfo',
                data: JSON.stringify(userCollectInfo),
              })
            } else if (isAndroid()) {
              window.PCJSKit.setUserCollectInfo(JSON.stringify(userCollectInfo))
            }
          } catch (error) {
            console.log(error)
          }
        } else if (data.browserEnv === 2 || data.browserEnv === 3) {
          data.postForm.source = 1
        }

        let cityId = data.locationInfo.cityId
        if (data.locationInfo.dataType === 'default') {
          cityId = -1
        }

        let postForm = {
          actId: Number(route.query.actId),
          brand: props.enrollSgInfo.brand,
          brandId: props.enrollSgInfo.brandId,
          captcha: data.postForm.captcha,
          city: data.locationInfo.city,
          cityId: cityId,
          currentFrom: window.location.href,
          dealerId: props.enrollSgInfo.dealerId,
          locationMessage: data.locationInfo.msg || '', // 城市定位信息:浏览器定位成功/失败,传百度sdk失败状态码
          locationType:
            data.locationInfo.dataType === 'geolocation'
              ? 1
              : data.locationInfo.dataType === 'ipJson'
              ? 2
              : data.locationInfo.dataType === 'user'
              ? 3
              : data.locationInfo.dataType === 'cookie' ||
                data.locationInfo.dataType === 'default'
              ? 0
              : 4, // 城市定位类型:0-其他，1-浏览器定位,2-ip定位,3-用户选择，4-定位失败
          locationVersion: data.locationInfo.version === '2.0.0' ? 2 : 1, // 城市定位版本:1-旧版本,2-新版本
          pcsuv: data.pcsuv || getCookie('pcsuv'),
          phone: data.postForm.encryptPhone,
          serialGroupId: props.enrollSgInfo.serialGroupId,
          serialGroupName: props.enrollSgInfo.serialOriginalName,
          source: data.postForm.source,
          sourceDetail: Number(route.query.sourceDetail),
          expireTime: props.enrollSgInfo.expireTime,
          discount: props.enrollSgInfo.maxDiscount,
        }
        if (data.locationInfo.dataType === 'default') {
          postForm.cityId = -1
        }
        let postDriveForm = {
          brand: props.enrollSgInfo.brand,
          brandId: props.enrollSgInfo.brandId,
          captcha: data.postForm.captcha,
          city: data.locationInfo.city,
          cityId: data.locationInfo.cityId,
          currentFrom: window.location.href,
          name: '客户',
          phone: data.postForm.encryptPhone,
          series: props.enrollSgInfo.serialOriginalName,
          seriesId: props.enrollSgInfo.serialGroupId,
          source: data.postForm.source,
          sourceDetail: Number(route.query.sourceDetail) || 7,
        }

        if (data.locationInfo.dataType === 'default') {
          postDriveForm.cityId = -1
        }
        const res: any =
          props.enrollSgInfo.type === 1
            ? await postDriveEnrollForm(postDriveForm)
            : await postEnrollForm(postForm)
        let isSuccess: any = true
        if (res.code === 200) {
          // 报名结果:1-成功留资,2-验证码错误,3-活动太火爆,请稍候再试,4-请输入合法参数
          if (res.data.code === 1) {
            if (data.browserEnv !== 1) {
              // cookie修改需要重新获取游戏信息
              setXunJiaInfo3Cookie({
                phone: curPhone,
                encryptPhone: data.postForm.encryptPhone,
              })
              store.dispatch('getGameInfo', {
                actId: route.query.actId,
                phone: data.postForm.encryptPhone,
              })
            }
            methods.toggleEnrollPopup(false)
            methods.clearForm()
            countAd(6334)
            isSuccess = true
            emit('enrollSuccess', props.enrollSgInfo.type)
          } else {
            Toast(res.data.msg)
            isSuccess = false
          }
        } else {
          Toast(res.data.message)
          isSuccess = false
        }
        // 活动留资结果返回
        sensors.PCautoActivityGetPriceResult(
          Number(route.query.actId),
          data.activityInfo.title,
          String(postForm.serialGroupId),
          isSuccess,
          res.data.msg,
        )
      },
      toggleSensitivePhoneInput() {
        setTimeout(() => {
          phoneInputRef.value.focus()
        })
      },
      // 跳转个人信息保护声明
      toLinkStatement() {
        const appUrl =
          'pcautobrowser://more/?uri=https://www1.pcauto.com.cn/zt/gz20171127/declare/app.html?hiddenShareBtn=1'
        const wapUrl =
          'https://www1.pcauto.com.cn/zt/gz20171127/declare/wap.html'
        const wxUrl =
          'https://www1.pcauto.com.cn/zt/gz20171127/declare/app.html'
        if (data.browserEnv === 3) {
          window.location.href = wapUrl
        } else if (data.browserEnv === 1) {
          window.location.href = appUrl
        } else {
          window.location.href = wxUrl
        }
      },
    }
    onBeforeMount(() => {
      methods.getVerifyCtrl()
    })
    return {
      ...toRefs(data),
      ...methods,
      phoneInputRef,
    }
  },
})
